import useHistory from './useHistory';
import { useStore } from '../store/store';
import { openInNewTabOnModifier, openInNewTabMenuItem } from '../utils/openInNewTab';

/**
 * Open-gesture wiring for a project / shared-project row.
 *
 * Given a thunk that builds the destination URL, returns the `onClick`
 * (Cmd/Ctrl-click opens a new tab; a plain click navigates in place after an
 * optional same-tab side effect) and the `linkContextMenu` "Open in new tab"
 * entry — both driven by the one thunk.
 *
 * Kept as a hook so the near-identical row components (the ProfilerProjects /
 * Projects list entries and the two SharedProjectEntry variants) don't each
 * re-declare the same handler wiring.
 *
 * @param {() => string} getUrl - builds the destination app path
 * @param {() => void} [beforeNavigate] - same-tab-only side effect (e.g. scroll save)
 * @returns {{ onClick: (event?: object) => void, linkContextMenu: Array }}
 */
export const useProjectRowOpen = (getUrl, beforeNavigate) => {
  const { navigate } = useHistory();
  const { utilsStore } = useStore();

  const openInNewTab = () => utilsStore.openInNewTab(getUrl());
  const onClick = openInNewTabOnModifier(openInNewTab, () => {
    beforeNavigate?.();
    navigate(getUrl());
  });

  return { onClick, linkContextMenu: [openInNewTabMenuItem(openInNewTab)] };
};
